import { TicketTicket } from '@/types/api'

export function isAileanUser(user?: { userId?: string } | null): boolean {
  return user?.userId === 'ailean'
}

export function isAileanTicket(ticket?: TicketTicket | null): boolean {
  return !!ticket?.additionalData?.some(data => data.key === 'ailean' && data.value === 'true')
}
